jQuery(document).ready(function($){
    $(document.body).removeClass('no-js').addClass('js');

    initPolyfills();

    // Utilities
    initClassToggle();
    initAnchorScroll();
    //initFullheightMobile();

    const toggleElements = document.querySelectorAll('.toggle_btn_js');

    // Function to handle click events outside the toggle button
    function handleOutsideClick(e) {
      toggleElements.forEach((item) => {
        const parent = item.parentNode;
        if (!parent.contains(e.target)) {
          parent.classList.remove('open');
        }
      });
    }

    if (toggleElements.length > 0) {
      toggleElements.forEach((item) => {
        item.addEventListener('click', (e) => {
          const parent = e.target.parentNode;
          parent.classList.toggle('open');
          e.stopPropagation(); // Prevent the click event from propagating to the document
        });
      });

      // Add a click event listener to the document to handle clicks outside the toggle buttons
      document.addEventListener('click', handleOutsideClick);
    }

});

function isMobile() {
    return window.matchMedia('(max-width:767px)').matches;
}

function initPolyfills() {
    // CSS object-fit for IE
    objectFitImages();

    // polyfill for IE - startsWith
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    // polyfill for IE - forEach
    if ('NodeList' in window && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
    }
}


/**
 * Toggle class on click
 */
function initClassToggle() {
    $(document.body).on('click', '[data-toggle="class"][data-class]', function(event) {
        var $trigger = $(this);
        var $target = $($trigger.data('target') ? $trigger.data('target') : $trigger.attr('href'));

        if($target.length) {
            event.preventDefault();
            $target.toggleClass($trigger.data('class'));
            $trigger.toggleClass('classed');
            $trigger.parent().parent().parent().toggleClass('classed');
        }
    });
}


/**
 * Smooth anchor scrolling
 */
function initAnchorScroll() {
    $('a[href*="#"]:not([data-toggle])').click(function(event) {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="'+this.hash.slice(1)+'"]');
            if (target.length && !target.parents('.woocommerce-tabs').length) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 1000);
            }
        }
    });
}


/*function initFullheightMobile() {
    // Fix mobile 100vh change on address bar show/hide
    var lastHeight = $(window).height();
    var heightChangeTimeout = undefined;
    if(isMobile()) {
        $('.vh').css('height', lastHeight);
    }
    (maybe_update_landing_height = function() {
        var winHeight = $(window).height();

        if(heightChangeTimeout !== undefined) {
            clearTimeout(heightChangeTimeout);
        }

        if(!isMobile()) {
            $('.vh').css('height', '');
        }
        else if(Math.abs(winHeight - lastHeight) > 100) {
            heightChangeTimeout = setTimeout(function() {
                var winHeight = $(window).height();
                $('.vh').css('height', winHeight);
                lastHeight = winHeight;
            }, 50);
        }
    })();
    $(window).resize(maybe_update_landing_height);
}*/

/*function initCopyToClipboard() {
  $(document.body).on('click', '[data-copy-to-clipboard]', function(event) {
    event.preventDefault();

    // Source: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
    var el = document.createElement('textarea');
    el.value = $(this).data('copy-to-clipboard');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  });
}*/

/* Global effects for resuse throughout the project */




function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    // Target classes
    var FADE_IN_CLASS = '.effect-fade-in';
    var BATCH_FADE_IN_CLASS = '.effect-batch-fade-in';

    // FADE-IN
    var y = 40;
    var targets = gsap.utils.toArray(FADE_IN_CLASS);

    targets.forEach(function (el) {
      gsap.from(el, { autoAlpha: 0, y: y, duration: 2, scrollTrigger: el });
    });

    // BATCH FADE-IN
    gsap.set(BATCH_FADE_IN_CLASS + ' > *', { autoAlpha: 0, y: y });
    ScrollTrigger.batch(BATCH_FADE_IN_CLASS + ' > *', {
      batchMax: 4,
      onEnter: function (targets, triggers) {
        gsap.to(targets, { autoAlpha: 1, y: 0, duration: 2, stagger: 0.30 });
      },
    });
}

initGsap();

jQuery(document).ready(function($) {
    var page = 1;
    var catId = 0;
    var postPerPage = 6;
    var loading = false;
    var selectedCatId = 0;

    function loadPosts() {
    if (!loading) {
        loading = true;
        $.ajax({
            url: _ajaxurl,
            type: 'POST',
            data: {
                action: 'load_more_posts',
                page_num: page,
                catid: selectedCatId 
            },
            success: function(response) {
                if (response) {
                    $('.module__latest-news .posts__container').append(response);
                    page++;
                    loading = false;
                } else {
                   
                    $('.btn--load-more').hide();
                   
                    page = 1;
                }
            },
            error: function() {
               
                $('.btn--load-more').hide();
               
                page = 1;
            }
        });
    }
}


    loadPosts();
    $('#apply-filter-btn').on('click', function(e) {
        e.preventDefault();
        page =1;
        $('.module__latest-news .posts__container').html('');
        // Get the selected category ID and name
         selectedCatId = $('.faq_nav a.active').data('catid');
        
        var categoryName = $('.faq_nav a.active').text();

        $('.toggle_btn_js').text(categoryName);

      
        loadPosts(selectedCatId);
    });

  
    $('.faq_nav a').on('click', function(e) {
        e.preventDefault();
     
        $('.faq_nav a').removeClass('active');
       
        $(this).addClass('active');
     
        $('.faq_nav').removeClass('open');
  
        var selectedCategoryText = $(this).text();
        $('.toggle_btn_js').text(selectedCategoryText);
       
       
    });


    $('.btn--load-more').on('click', function() {
        loadPosts();
    });
});

function wavesMapInit() {
    console.log('init map');
    
    const module = document.querySelector('.module__tides_and_waves');
    if (!module) return;

    const mapTitle = module.querySelector('.locations-header__title h2');
    const mapLat = module.querySelector('.locations-header__lat')
    const mapLng = module.querySelector('.locations-header__lng')

    const mapPoints = module.querySelectorAll('.module__tides_and_waves__map-points .map-point');

    const locationsToggleBtn = module.querySelectorAll('.locations-dropdown .location-item');
    const locationsList = module.querySelector('.locations-list');

    locationsToggleBtn?.forEach(btn => {
        btn.addEventListener('click', () => {
            const lat = btn.dataset.locationLat;
            const lng = btn.dataset.locationLng;
            const name = btn.dataset.locationName;

            mapTitle.textContent = name;
            mapLat.textContent = `Latitude: ${lat}`;
            mapLng.textContent = `Longitude: ${lng}`;

            // Update the map view here
            locationsList.querySelectorAll('.location').forEach(item => item.classList.remove('active'));
            locationsList.querySelector(`.location[data-location="${name}"]`).classList.add('active');
        });
    });

    mapPoints?.forEach(point => {
        point.addEventListener('click', () => {
            const lat = point.dataset.locationLat;
            const lng = point.dataset.locationLng;
            const name = point.dataset.locationName;

            mapTitle.textContent = name;
            mapLat.textContent = `Latitude: ${lat}`;
            mapLng.textContent = `Longitude: ${lng}`;

            // Update the map view here
            locationsList.querySelectorAll('.location').forEach(item => item.classList.remove('active'));
            locationsList.querySelector(`.location[data-location="${name}"]`).classList.add('active');
        });
    });
}

wavesMapInit();